import { buildQueryParams } from "src/utils"
import { APICall } from ".."

const ControllerName = "MobManualRequests"

export const GetDecisionsForManualReceive = (searchData: any, tableFiller: any) => {
    const searchParams = buildQueryParams(searchData)
    return APICall("get", ControllerName + `/GetDecisionsForManualRecieve${searchParams}`)
}

export const GetMedicinesForManualReceive = (requestId: any, pharmacyId: any, hospitalId: any) => {
    return APICall("get", ControllerName + `/GetMedicinesForManuallyRecieve?requestId=${requestId || ""}&pharmacyId=${pharmacyId || ""}&hospitalId=${hospitalId || ""}`)
}

export const SubmitManualRequest = (data: any) => {
    return APICall("post", ControllerName + "/SubmitManualRequest", data)
}

